import Mixin from "../../mixin.js";
import Funnel from "../../services/funnel-service.js";
import Utils from "../../services/utils-service.js";
import tooltip from "./tooltip.js"
const template = `
    <label
        :label-for="computed_for"
        :for="computed_for"
        :class="computedLabelClass"
        :id="computedLabelId"
        :data-uid="iuid+'_lb'"
        :name="computed_for"
    >
        <span v-if="item || format == 'custom'" :class="img && ((input.type == 'checkbox' || format == 'custom') && input.type != 'radio') ? 'card_':''" class="label-container">
            <b-tooltip :element='item' v-if="item.helpText && input.type != 'checkbox' && input.type != 'radio'"/>
            <img  :class="svgClass" :src="img" v-if="img && !multiselect" :alt="computedLabel(item)">
            <span v-html="parseHtml(computedLabel(item))"></span>
        </span>
        <span v-else class="label-container">
            <img  :class="svgClass" :src="img" v-if="img && !multiselect" :alt="computedLabel(input)">
            <span v-html="parseHtml(computedLabel(input))"></span>
            <b-tooltip :element='input' v-if="input.helpText"/>
        </span>

        
    </label>
`;

export default {
    name: 'qt-label',
    template,
    components: {
        'b-tooltip': tooltip
    },
    props: ['iuid', 'format', 'img', 'item', 'item_index', 'multiselect'],
    mixins: [Mixin],
    mounted(){
        if (this.input.helpText) {
            console.log(this.input.uid,this.input.helpText);
        }
    },
    computed: {
        fs: function () {
            return new Funnel({ ctx: this.$store, router: this.$router });
        },
        computedLabelId: function(){
            if (this.item && this.item_index) {
                return "label_"+this.iuid +"_"+ this.item_index
            }else{
                return "label_"+this.iuid
            }
           
        },
        computedHelpText: function () { 
            return this.input.helpText
        },
        computedLabelClass: function () {

            var labelClass = []
            //:class="format == 'basic' ? '' : input.label_class"
            //remember to include the basic conditional in the return string
            self = this
            // this.$nextTick(function(){
            //     console.log(self.input.uid, self.input.value);
            //     console.log(self.input.uid, self.input.type);
            // })
            
            if (this.input.value && (this.input.select_type != 2)) {
                labelClass.push('complete')
            }
            if (this.input.label_class && !this.multiselect) {
                labelClass.push(this.input.label_class)
            }
            // if (this.input.helpText && this.item_index == undefined) {
            //     labelClass.push('tooltip')
            // }
            if (this.input.type == 'radio' && this.input.options[0].value.toLowerCase() != 'yes' && this.input.options[1].value.toLowerCase() != 'no') {
                labelClass.push('no-check')
            }
            if (this.format == 'basic' || this.multiselect) {
                return labelClass
            }
            if (this.input.type == 'checkbox') {
                if (this.input.options[this.item_index].disabled) {
                    labelClass.push('disabled')
                }
                if (this.input.checkbox_type == 'inline' || this.input.checkbox_type == 2) {
                    labelClass.push('inline-checkbox-label')
                }
            }
            if (this.input.validation) {
                if (this.input.validation.required ) {
                    labelClass.push('required')
                }

            }
            var  textLabels = ["text", "select", "phone", "email", "number", "cvv", "cc"];
            
            if (this.input.helpText && textLabels.includes(this.input.type)) {
                if (this.input.helpText.content) {
                    console.log(this.input.uid +" helptext label");
                    labelClass.push('tooltip-label') 
                }
            }
            return labelClass
        },
        svgClass: function () {
            // console.log(this.input);
            if (this.img.indexOf('.svg') != -1) {
                if (this.input.type == "twin-button-card") {
                    return 'icon iconic-sm'
                } else {
                    return 'icon iconic'
                }

            }
        },
        input: function () {
            return this.$store.getters.funnel.elements[this.iuid];
        },
        computed_for: function () {
            if (this.input.type == 'checkbox' || this.format == 'custom') {
                return this.input.uid + '_option_' + this.item_index
            }
            else {
                return this.iuid
            }
        }
    },
    methods: {
        // John M: deprecated, see mixin.
        /* computedLabel: function (obj) {
            let labelText = obj.label;
            let self = this;
            if (!Utils.isObjEmpty(obj.labels)) {
                for (const label of obj.labels) {
                    if (self.fs.display(label)) {
                        labelText = label.text;
                    }
                }
            }
            return labelText;
        }, */
    }
};